import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
export type MaterialShoreHardnessFragmentFragment = { __typename?: 'ShoreHardness', custom: boolean, default: boolean, id: number, name: string };

export const MaterialShoreHardnessFragmentFragmentDoc = gql`
    fragment materialShoreHardnessFragment on ShoreHardness {
  custom
  default
  id
  name
}
    `;